(function () {
  'use strict';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = String(text);
    return node;
  }

  function append(parent) {
    for (var i = 1; i < arguments.length; i += 1) {
      if (arguments[i]) parent.appendChild(arguments[i]);
    }
    return parent;
  }

  function splitLines(value) {
    return String(value || '').split(/\r?\n/).map(function (line) { return line.trim(); }).filter(Boolean);
  }

  function slug(value) {
    return String(value).toLowerCase().replace(/\s*\/\s*/g, '-').replace(/\s+/g, '-');
  }

  function validUrl(value, fallback) {
    try { return new URL(value, window.location.origin).toString(); } catch (error) { return fallback; }
  }

  function init(root) {
    var source = window.SonarShieldSafetyData;
    if (!source || !source.translations) {
      root.appendChild(el('p', 'sssl-error', 'The product safety information could not be loaded.'));
      return;
    }

    if (root.dataset.standalone === 'true') document.body.classList.add('sssl-standalone');

    var customNode = root.querySelector('[data-sssl-custom-products]');
    var customProducts = [];
    if (customNode) {
      try { customProducts = JSON.parse(customNode.textContent || '[]'); } catch (error) { customProducts = []; }
      customNode.remove();
    }

    var data = {
      languages: source.languages.slice(),
      categories: source.categories.slice(),
      products: source.products.slice(),
      translations: source.translations
    };

    customProducts.filter(function (item) { return item.enabled && item.model && item.name; }).forEach(function (item) {
      if (data.products.some(function (product) { return product.model === item.model; })) return;
      data.products.push({model: item.model, category: item.category, gtin: item.gtin || '', custom: true});
      data.translations.en.products[item.model] = {
        name: item.name,
        compat: item.compat,
        material: item.material,
        origin: item.origin,
        contents: item.contents,
        desc: item.desc,
        features: splitLines(item.features),
        use: item.use,
        warning: item.warning,
        risk: item.risk,
        mitigations: splitLines(item.mitigations)
      };
    });

    var params = new URLSearchParams(window.location.search);
    var requestedLang = params.get('lang') || root.dataset.defaultLang || 'en';
    if (requestedLang === 'nb' || requestedLang === 'nn') requestedLang = 'no';
    var lang = data.translations[requestedLang] ? requestedLang : 'en';
    var locale = data.translations[lang];
    var t = locale.ui;
    var visibleProducts = data.products.filter(function (product) { return Boolean(locale.products[product.model]); });
    var requestedProduct = params.get('product');
    var active = visibleProducts.find(function (product) { return slug(product.model) === requestedProduct; }) || visibleProducts[0];

    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.title = 'Sonar Shield® — ' + t.title;
    root.dir = lang === 'ar' ? 'rtl' : 'ltr';

    function productUrl(product, nextLang) {
      var url = new URL(window.location.href);
      url.searchParams.set('lang', nextLang || lang);
      url.searchParams.set('product', slug(product.model));
      return url;
    }

    function copyLink(button) {
      var original = t.copyDirectLink;
      var value = productUrl(active, lang).toString();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(function () {
          button.textContent = t.linkCopied;
          window.setTimeout(function () { button.textContent = original; }, 1400);
        });
      }
    }

    function languageSelector() {
      var label = el('label', 'sssl-label');
      label.appendChild(el('span', '', t.language));
      var select = el('select', 'sssl-select');
      select.setAttribute('aria-label', t.language);
      data.languages.forEach(function (language) {
        var option = el('option', '', language.native);
        option.value = language.code;
        option.selected = language.code === lang;
        select.appendChild(option);
      });
      select.addEventListener('change', function () {
        window.location.assign(productUrl(active, select.value).toString());
      });
      label.appendChild(select);
      return label;
    }

    function groupedProducts(parent, makeItem) {
      data.categories.forEach(function (category) {
        var items = visibleProducts.filter(function (product) { return product.category === category; });
        if (!items.length) return;
        makeItem(parent, category, items);
      });
    }

    function productSelector() {
      var label = el('label', 'sssl-label');
      label.appendChild(el('span', '', t.product));
      var select = el('select', 'sssl-select');
      select.setAttribute('aria-label', t.product);
      groupedProducts(select, function (parent, category, items) {
        var group = document.createElement('optgroup');
        group.label = t.categories[category] || category;
        items.forEach(function (product) {
          var option = el('option', '', product.model + ' — ' + locale.products[product.model].name);
          option.value = product.model;
          option.selected = product.model === active.model;
          group.appendChild(option);
        });
        parent.appendChild(group);
      });
      select.addEventListener('change', function () {
        var selected = visibleProducts.find(function (product) { return product.model === select.value; });
        if (!selected) return;
        active = selected;
        window.history.replaceState({}, '', productUrl(active, lang));
        renderProduct();
        renderIndex();
        document.getElementById('sssl-details-' + root.dataset.sectionId).scrollIntoView({behavior: 'smooth', block: 'start'});
      });
      label.appendChild(select);
      return label;
    }

    var topbar = el('header', 'sssl-topbar');
    var brand = el('a', 'sssl-brand');
    brand.href = '#sssl-top-' + root.dataset.sectionId;
    brand.setAttribute('aria-label', t.homeLabel);
    var logo = el('img');
    logo.src = root.dataset.logo;
    logo.alt = 'Sonar Shield®';
    logo.width = 224;
    logo.height = 59;
    brand.appendChild(logo);
    var siteLink = el('a', 'sssl-site-link', 'TheSonarShield.com ↗');
    siteLink.href = validUrl(root.dataset.storeUrl, '/');
    append(topbar, brand, siteLink);

    var hero = el('section', 'sssl-hero');
    var heroInner = el('div', 'sssl-hero-inner');
    append(heroInner,
      el('span', 'sssl-eyebrow', '— ' + t.officialInfo),
      el('h1', '', t.title),
      el('p', '', t.heroDescription)
    );
    var remove = el('div', 'sssl-remove');
    append(remove, el('b', '', t.remove), document.createTextNode(t.removeText));
    heroInner.appendChild(remove);
    append(hero, el('div', 'sssl-grid'), heroInner);

    var nav = el('nav', 'sssl-nav');
    var navInner = el('div', 'sssl-nav-inner');
    var navCopy = el('button', 'sssl-copy', t.copyDirectLink);
    navCopy.type = 'button';
    navCopy.addEventListener('click', function () { copyLink(navCopy); });
    append(navInner, languageSelector(), productSelector(), navCopy);
    nav.appendChild(navInner);

    var aside = el('aside', 'sssl-index');
    var productHost = el('section', 'sssl-card sssl-product');
    productHost.id = 'sssl-details-' + root.dataset.sectionId;

    function renderIndex() {
      aside.replaceChildren(el('h2', '', t.productIndex));
      groupedProducts(aside, function (parent, category, items) {
        var section = el('section');
        section.appendChild(el('h3', '', t.categories[category] || category));
        items.forEach(function (product) {
          var button = el('button', product.model === active.model ? 'is-active' : '');
          button.type = 'button';
          button.setAttribute('aria-current', product.model === active.model ? 'true' : 'false');
          append(button, el('b', '', product.model), el('span', '', locale.products[product.model].name));
          button.addEventListener('click', function () {
            active = product;
            window.history.replaceState({}, '', productUrl(active, lang));
            var select = nav.querySelectorAll('select')[1];
            if (select) select.value = active.model;
            renderProduct();
            renderIndex();
            productHost.scrollIntoView({behavior: 'smooth', block: 'start'});
          });
          section.appendChild(button);
        });
        parent.appendChild(section);
      });
    }

    function spec(label, value) {
      var div = el('div');
      append(div, el('b', '', label), el('p', '', value));
      return div;
    }

    function renderProduct() {
      var p = locale.products[active.model];
      productHost.replaceChildren();
      var top = el('div', 'sssl-product-top');
      var meta = el('span', 'sssl-product-meta');
      append(meta, el('b', 'sssl-model', active.model), el('small', 'sssl-category', t.categories[active.category] || active.category));
      var iconCopy = el('button', 'sssl-icon-copy', '↗');
      iconCopy.type = 'button';
      iconCopy.setAttribute('aria-label', t.copyProductLabel);
      iconCopy.addEventListener('click', function () { copyLink(navCopy); });
      append(top, meta, iconCopy);
      append(productHost, top, el('h2', '', p.name), el('p', 'sssl-description', p.desc));

      var specs = el('div', 'sssl-specs');
      append(specs,
        spec(t.compatibility, p.compat),
        spec(t.material, p.material),
        spec(t.origin, p.origin),
        spec(t.contents, p.contents)
      );
      if (active.gtin) specs.appendChild(spec(t.gtin, active.gtin));
      productHost.appendChild(specs);

      var warning = el('div', 'sssl-warning');
      var warningText = el('span');
      append(warningText, el('b', '', t.safetyWarning), el('p', '', p.warning));
      append(warning, el('i', 'sssl-alert-circle', '!'), warningText);
      productHost.appendChild(warning);

      var risk = el('section', 'sssl-risk');
      append(risk, el('span', 'sssl-record-label', t.productFile), el('h3', '', t.risksTitle), el('p', '', p.risk));
      productHost.appendChild(risk);

      var mitigation = el('section', 'sssl-mitigation');
      append(mitigation, el('span', 'sssl-record-label', t.requiredActions), el('h3', '', t.mitigationTitle));
      var mitigationList = el('ul');
      (p.mitigations || []).forEach(function (action) { mitigationList.appendChild(el('li', '', action)); });
      mitigation.appendChild(mitigationList);
      productHost.appendChild(mitigation);

      var columns = el('div', 'sssl-columns');
      var care = el('article');
      append(care, el('h3', '', t.useCare), el('p', '', p.use));
      var features = el('article');
      features.appendChild(el('h3', '', t.keyFeatures));
      var featureList = el('ul');
      (p.features || []).forEach(function (feature) { featureList.appendChild(el('li', '', feature)); });
      features.appendChild(featureList);
      append(columns, care, features);
      productHost.appendChild(columns);
      if (lang !== 'en') productHost.appendChild(el('p', 'sssl-review', t.machineNotice));
    }

    var universal = el('section', 'sssl-card sssl-universal');
    append(universal, el('em', 'sssl-kicker', t.appliesAll), el('h2', '', t.universalTitle), el('p', '', t.universalText));
    var safetyGrid = el('div', 'sssl-safety-grid');
    t.safetyCards.forEach(function (card, index) {
      var article = el('article');
      var wording = el('span');
      append(wording, el('strong', '', card.title), document.createTextNode(card.body));
      append(article, el('b', 'sssl-number', String(index + 1).padStart(2, '0')), wording);
      safetyGrid.appendChild(article);
    });
    universal.appendChild(safetyGrid);
    var notes = el('div', 'sssl-notes');
    notes.appendChild(el('h3', '', t.additionalSafetyTitle));
    var notesList = el('ul');
    t.additionalSafetyItems.forEach(function (item) { notesList.appendChild(el('li', '', item)); });
    notes.appendChild(notesList);
    universal.appendChild(notes);
    var prop65 = el('section', 'sssl-prop65');
    var propBody = el('div');
    append(propBody, el('span', 'sssl-prop65-label', t.prop65Label), el('h3', '', t.prop65Title), el('p', '', t.prop65Body));
    var propLink = el('a', '', t.prop65Link + ' ↗');
    propLink.href = validUrl(root.dataset.prop65Url, 'https://www.p65warnings.ca.gov/');
    propBody.appendChild(propLink);
    append(prop65, el('i', 'sssl-alert-triangle', '!'), propBody);
    universal.appendChild(prop65);

    var contacts = el('section', 'sssl-card sssl-contacts');
    var manufacturer = el('div');
    append(manufacturer, el('b', 'sssl-contacts-label', t.manufacturerLabel), el('h3', '', root.dataset.manufacturerName), el('p', '', root.dataset.manufacturerAddress || t.manufacturerLocation));
    var service = el('div');
    service.appendChild(el('b', 'sssl-contacts-label', t.customerService));
    var email = el('a', '', root.dataset.supportEmail);
    email.href = 'mailto:' + root.dataset.supportEmail;
    var phone = el('a', '', root.dataset.supportPhone);
    phone.href = 'tel:' + root.dataset.supportPhone.replace(/[^+\d]/g, '');
    append(service, email, phone);
    var eu = el('div');
    append(eu, el('b', 'sssl-contacts-label', t.euPerson), el('h3', '', root.dataset.euName), el('p', '', root.dataset.euDetails || t.earpPending));
    append(contacts, manufacturer, service, eu);

    var content = el('div', 'sssl-content');
    append(content, universal, productHost, contacts, el('p', 'sssl-disclaimer', t.disclaimer));
    var shell = el('div', 'sssl-shell');
    append(shell, aside, content);

    var footer = el('footer', 'sssl-footer');
    var back = el('a', '', t.backToTop + ' ↑');
    back.href = '#sssl-top-' + root.dataset.sectionId;
    append(footer, el('b', '', 'SONAR SHIELD®'), el('span', '', t.footerText), back);

    root.id = 'sssl-top-' + root.dataset.sectionId;
    root.replaceChildren(topbar, hero, nav, shell, footer);
    renderIndex();
    renderProduct();
  }

  function start() {
    document.querySelectorAll('[data-sonar-safety-library]').forEach(function (root) {
      if (!root.dataset.initialized) {
        root.dataset.initialized = 'true';
        init(root);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
